import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-522105f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "memberlist" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "display-2 mb-4",
  style: {"text-align":"center"}
}, "Medlemmer", -1))
const _hoisted_3 = { class: "layout gutter--md" }
const _hoisted_4 = { class: "searchControls row row align--center justify--space-around mb-4" }
const _hoisted_5 = { class: "md2 flex mobile sm1" }
const _hoisted_6 = {
  class: "md5 flex xs12 sm5",
  style: {"display":"flex"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_8 = { class: "md3 flex xs12 sm4" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_11 = {
  class: "va-table va-table--clickable va-table--hoverable memberTable",
  style: {"width":"75%"}
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "center mobileTable" }
const _hoisted_14 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_15 = {
  key: 1,
  style: {"text-align":"right"}
}
const _hoisted_16 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_18 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_19 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_21 = { class: "selectPageSize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_divider = _resolveComponent("va-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_va_button, {
            class: "btn",
            color: "#b4003a",
            rounded: false,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.columnSort('reset')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_va_icon, {
                class: "reset",
                name: "autorenew"
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_va_input, {
            modelValue: _ctx.memberSearchInputValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.memberSearchInputValue) = $event)),
            label: "Søg",
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.findMember()), ["enter"])),
            style: {"width":"85%"}
          }, {
            prependInner: _withCtx(() => [
              _createVNode(_component_va_icon, { name: "travel_explore" })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_va_button, {
            class: "btn ml-2",
            color: "#b4003a",
            rounded: false,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.findMember()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_va_icon, { name: "search" }),
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_va_select, {
            label: "Filtrer efter klub",
            modelValue: _ctx.filterByClubValue,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterByClubValue) = $event)),
            options: _ctx.filterByClubOptions,
            searchable: "",
            bordered: ""
          }, null, 8, ["modelValue", "options"])
        ])
      ])
    ]),
    _createVNode(_component_va_divider),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.error), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("table", _hoisted_11, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.columnSort('navn')))
                }, "Navn"),
                _createElementVNode("th", {
                  class: "center sorting mobileTable",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.columnSort('licens')))
                }, "Licensnummer"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.columnSort('klub'))),
                  style: {"text-align":"right"}
                }, "Klub")
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medlemers, (medlem, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  onClick: ($event: any) => (_ctx.toMemberInfo(medlem.id, medlem.user_id.firstname, medlem.user_id.lastname))
                }, [
                  _createElementVNode("td", null, _toDisplayString(medlem.user_id.firstname + ' ' + medlem.user_id.lastname), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(medlem.medlem_licens), 1),
                  ((medlem.klubber_id === null))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_14, "Ingen klub"))
                    : (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(medlem.klubber_id.klubber_klubnavn), 1))
                ], 8, _hoisted_12))
              }), 128))
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_va_button, {
        icon: "first_page",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.jumpToPage(1)))
      }),
      _createVNode(_component_va_button, {
        icon: "keyboard_double_arrow_left",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.turnToNewPage(-5)))
      }),
      _createVNode(_component_va_button, {
        icon: "chevron_left",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.turnToNewPage(-1)))
      }),
      _hoisted_17,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.currentPage) = $event)),
        type: "number",
        onKeyup: _cache[12] || (_cache[12] = _withKeys(($event: any) => (_ctx.jumpToPage(this.currentPage)), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.currentPage]
      ]),
      (_ctx.totalNumberOfPages === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_18, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_19, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
      _createVNode(_component_va_button, {
        icon: "chevron_right",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.turnToNewPage(1)))
      }),
      _createVNode(_component_va_button, {
        icon: "keyboard_double_arrow_right",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.turnToNewPage(5)))
      }),
      _createVNode(_component_va_button, {
        icon: "last_page",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.jumpToPage(_ctx.totalNumberOfPages)))
      }),
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_va_select, {
          class: "mr-2",
          modelValue: _ctx.pageSizeValueString,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
          options: _ctx.pageSizeOptions,
          bordered: ""
        }, null, 8, ["modelValue", "options"])
      ])
    ])
  ]))
}